import { Component, inject, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { OrderData } from '@lfw/roesberg.liveforms.core';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { LfwRouterService } from '../../../route/lfw-router.service';
import { AppToolbarButtonComponent } from '../../../shared/components/app-toolbar-button/app-toolbar-button.component';
import { AppToolbarTextComponent } from '../../../shared/components/app-toolbar-text/app-toolbar-text.component';
import { AppToolbarComponent } from '../../../shared/components/app-toolbar/app-toolbar.component';
import { OrderResolved } from '../../../shared/models/order-resolved';
import { InfoService } from '../../../shared/services/info.service';
import { OrderDetailsComponent } from '../../components/order-details/order-details.component';

@Component({
  selector: 'lfw-online-order-details-view',
  imports: [
    AppToolbarButtonComponent,
    AppToolbarComponent,
    AppToolbarTextComponent,
    OrderDetailsComponent,
    TranslatePipe
  ],
  templateUrl: './online-order-details-view.component.html',
  styleUrl: './online-order-details-view.component.css'
})
export class OnlineOrderDetailsViewComponent implements OnInit {
  order: OrderData | undefined = undefined;

  private readonly routerService = inject(LfwRouterService);
  private readonly translate = inject(TranslateService);
  private readonly route = inject(ActivatedRoute);
  private readonly infoService = inject(InfoService);
  private readonly title = inject(Title);

  constructor() {
    this.infoService.clearStatus();
  }

  ngOnInit(): void {
    this.route.data.subscribe((data) => {
      const orderResolved: OrderResolved = data['order'];
      if (orderResolved.order) {
        this.order = orderResolved.order;
        this.title.setTitle(this.order.text);
      } else {
        this.error(orderResolved.orderId);
      }

      if (orderResolved.error) {
        this.infoService.setStatus(orderResolved.error);
      } else {
        this.infoService.clearStatus();
      }
    });
  }

  get caption(): string {
    return this.order?.text ?? '';
  }

  error(formId: string): void {
    this.infoService.setStatus(this.translate.instant('FORM.DLG_FORM_ID_NOT_FOUND', { id: formId }));
  }

  close(): void {
    this.routerService.navigateToOrdersRoot();
  }
}
